import { render } from "./favouriteArticle.vue?vue&type=template&id=0101b9d5&scoped=true"
import script from "./favouriteArticle.vue?vue&type=script&lang=js"
export * from "./favouriteArticle.vue?vue&type=script&lang=js"

import "./favouriteArticle.vue?vue&type=style&index=0&id=0101b9d5&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0101b9d5"]])

export default __exports__